<div
    role="tooltip"
    [class]="'agpr-popover ' + styleClass"
    [ngClass]="{
        'agpr-popover--top': position === directionsEnum.top,
        'agpr-popover--right': position === directionsEnum.right,
        'agpr-popover--bottom': position === directionsEnum.bottom,
        'agpr-popover--left': position === directionsEnum.left
    }"
>
    <div class="agpr-popover-body">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
</div>
